import { VIOLATIONS_CHAR_LIMIT } from "@lib/shared/models";

const paCriminalComplaintEntityType = {
    fields: [
        {
            name: 'id',
            label: 'id',
            validators: {}
        },
        {
            name: 'isJuvenile',
            label: 'Charging Document Type',
            validators: { required: true, }
        },
    ],
    customFields: []
};

const paCriminalComplaintAttorneyForState = {
    fields: [
        {
            name: 'id',
            label: 'id',
            validators: {}
        },
        {
            name: 'attorneyForStateApproved',
            label: 'Approved',
            validators: {}
        },
        {
            name: 'attorneyForStateDisapprovedReason',
            label: 'Reason',
            validators: {}
        },
        {
            name: 'attorneyForStateName',
            label: 'Name of Attorney',
            validators: {}
        },
        {
            name: 'attorneyForStateDate',
            label: 'Date',
            validators: {}
        },

    ],
    customFields: []
};

const paCriminalComplaintPrimaryInfo = {
    fields: [
        {
            name: 'id',
            label: 'id',
            validators: {}
        },
        {
            name: 'countyId',
            label: 'County'
        },
        {
            name: 'courtId',
            label: 'Court'
        },
        {
            name: 'judgeId',
            label: 'Judge',
        },
        {
            name: 'docketNumber',
            label: 'Docket Number',
        },
        {
            name: 'dateFiled',
            label: 'Date Filed',
        },
        {
            name: 'courtAppearanceDate',
            label: 'Court Appearance Date',
        },
        {
            name: 'offenseTrackingNumber',
            label: 'Offense Tracking Number',
        },
        {
            name: 'liveScanNumber',
            label: 'LiveScan Number',
        },
        {
            name: 'complaintNumber',
            label: 'Charging Document Number',
        },
        {
            name: 'allegationNumber',
            label: 'Charging Document Number',
        },
        {
            name: 'isRequestLabServices',
            label: 'Request Lab Services',
        },
        {
            name: 'ncicExtraditionCodeTypeId',
            label: 'NCIC Extradition Code Type',
        },
        {
            name: 'otn',
            label: 'Offense Tracking Number',
        },
        {
            name: 'extraditionDistance',
            label: 'Extradition Distance'
        },
        {
            name: 'initiationType',
            label: 'Initiation Type'
        },
    ],
    customFields: []
}

const paCriminalComplaintAffiantItems = {
    fields: [
        {
            name: 'id',
            label: 'id',
            validators: {}
        },
        {
            name: 'employeeId',
            label: 'id',
            validators: {}
        },
        {
            name: 'agencyId',
            label: 'id',
            validators: {}
        },
        {
            name: 'dualEmployee',
            label: 'Dual Affiant Employee',
            validators: {}
        },
        {
            name: 'dualAgency',
            label: 'Dual Affiant Agency',
            validators: {}
        },
        {
            name: 'witnessingOfficerId',
            label: 'Witnessing Officer',
            validators: {}
        },
        {
            name: 'witnessingAgencyId',
            label: 'Witnessing Agency',
            validators: {}
        },
        {
            name: 'swornDate',
            label: 'Sworn Date',
            validators: {}
        },
        {
            name: 'municipalityId',
            label: 'Subdivision Code',
            validators: {}
        },
        {
            name: 'addressId',
            label: 'Location',
            validators: {}
        },
        {
            name: 'countyId',
            label: 'County',
            validators: {}
        },
        {
            name: 'accusedType',
            label: 'Accusation',
        },
        {
            name: 'accusedUnknownDescription',
            label: 'Description of unknown person',
            disabled: true
        },
        {
            name: 'offenseDateType',
            label: 'Offense Date Type',
        },
        {
            name: 'onOrAboutDate',
            label: 'On or About Date',
        }, {
            name: 'betweenStartDate',
            label: 'Between',
        },
        {
            name: 'betweenEndDate',
            label: 'and',
        },
        {
            name: 'isRequestingArrestWarrant',
            validators: {
                required: true
            }
        }

    ],
    customFields: [
    ]
};

const paCriminalComplaintAccusationItems = {
    fields: [
        {
            name: 'id',
            label: 'id',
            validators: {}
        },
    ],
    customFields: [
    ]
};


const paCriminalComplaintChargesData = {
    fields: [
        {
            name: 'id',
            label: 'id',
            validators: {}
        },
        {
            name: 'occurredFrom',
            label: 'Occurred From',
            validators: {
                required: true
            }
        },

        {
            name: 'occurredTo',
            label: 'Occurred To',
            validators: {}
        },
        {
            name: 'violations',
            label: 'Offenses',
            validators: {
                maxlength: VIOLATIONS_CHAR_LIMIT
            }
        },
        {
            name: 'addContinuationPage',
            label: 'Add A Continuation Page',
            validators: {}
        },
        {
            name: 'violationsContinued',
            label: '',
            validators: {}
        }
    ],
    customFields: [
    ]
};

const paCriminalComplaintConfidentialInformation = {
    fields: [
        {
            name: 'id',
            label: 'id',
            validators: {}
        },
        {
            name: 'isConfidentialPerson',
            label: 'Has Confidential Information'
        },
        {
            name: 'socialSecurityNumberIdentifierId',
            label: 'Social Security Number',
        },
        {
            name: 'socialSecurityNumberAlternate',
            label: 'Alternate'
        },
        {
            name: 'stateIdentifierNumberIdentifierId',
            label: 'State Issued Identification',
        },
        {
            name: 'stateIdentifierNumberAlternate',
            label: 'Alternate'
        },
        {
            name: 'financialAccountNumberIdentifierId',
            label: 'Financial Account Number',
        },
        {
            name: 'financialAccountNumberAlternate',
            label: 'Alternate'
        },
        {
            name: 'driverLicenseNumberIdentifierId',
            label: 'Driver\'s License',
        },
        {
            name: 'driverLicenseNumberAlternate',
            label: 'Alternate'
        },
        {
            name: 'driverLicenseStateId',
            label: 'State'
        },
        {
            name: 'driverLicenseExpirationDate',
            label: 'Expiration Date'
        },
        {
            name: 'linkDate',
            label: 'Link Date'
        },
        {
            name: 'comment',
            label: 'Comment'
        },
        {
            name: 'isJuvenileRelated',
            label: 'Juvenile Related'
        },
        {
            name: 'juvenileInitials',
            label: 'Juvenile Initials'
        },
        {
            name: 'sequence',
            label: 'Sequence'
        },
        {
            name: 'isSubpoenaRequired',
            label: 'Subpoena Required'
        },

        {
            name: 'personPhone',
            label: 'Primary Phone'
        },
        {
            name: 'personPhoneSuffix',
            label: 'Ext.'
        },
        {
            name: 'personEmail',
            label: 'Primary Email'
        },
        {
            name: 'linkTypeIds',
            label: 'Select An Involvement Code',
            validators: {
                minlength: 1,
                required: true
            }
        },
        {
            name: 'defendantCourtInformationIds',
            label: 'Additional Court Information',
            validators: {}
        },
        {
            name: 'isSameAddressAsJuvenile',
            label: 'Same Address as Juvenile Defendant',
            validators: {}
        }
    ],
    customFields: [
    ]
};

const paCriminalComplaintDefendantItems = {
    fields: [
        {
            name: 'id',
            label: 'id',
            validators: {}
        },
        {
            name: 'countryId',
            label: 'Country',
            validators: {}
        },
        {
            name: 'foreignStateCode',
            label: 'Foreign State Code',
            validators: {}
        },
        {
            name: 'mnuPersonIdentifierId',
            label: 'MNU Identifier',
            validators: {}
        },
        {
            name: 'isDna',
            label: 'DNA',
            validators: {}
        },
        {
            name: 'dnaLocationId',
            label: 'DNA Location',
            validators: {}
        },
        {
            name: 'isFingerprinted',
            label: 'Fingerprinted',
            validators: {}
        },
        {
            name: 'fingerPrintClassification',
            label: 'Fingerprint Classification',
            validators: {}
        },
        {
            name: 'isSubpoenaRequired',
            label: 'Subpoena Required',
            validators: {}
        },
        {
            name: 'affiantOrAttorneyName',
            label: 'Affiant or Attorney Name',
            validators: {}
        },
        {
            name: 'attorneyNumber',
            label: 'Attorney Number',
            validators: {}
        },
        {
            name: 'affiantPhone',
            label: 'Phone',
            validators: {}
        },
        {
            name: 'affiantEmail',
            label: 'Email',
            validators: {}
        },
        {
            name: 'defendantDetailNCICCautionMedicalCodes',
            label: 'NCIC Caution/Medical Codes'
        },
        {
            name: 'physicalFeatureCodeIds',
            label: 'Select Up to 9 NCIC Codes'
        },
        {
            name: 'fullName',
            label: `Full Name`,
            validators: {}
        },
        {
            name: 'juvenileInitials',
            label: `Minor's Initials`,
            validators: {}
        },
        {
            name: 'juvenileDateOfBirth',
            label: `Minor's Date of Birth`,
            validators: {}
        },
        {
            name: 'affiantPhoneSuffix',
            label: `Suffix`,
            validators: {}
        },
        {
            name: 'affiantAddressId',
            label: `Affiant Address`,
            validators: {}
        },
        {
            name: 'mnuIdentifierTypeId',
            label: 'MNU Type',
            validators: {}
        },
        {
            name: 'otherNcicCautionMedicalCode1',
            label: 'Other Code',
            validators: {}
        },
        {
            name: 'otherNcicCautionMedicalCode2',
            label: 'Other Code',
            validators: {}
        },
        {
            name: 'isPhotographed',
            label: 'Photographed',
            validators: {}
        }
    ],
    customFields: [
    ]
};


const paCriminalComplaintAffidavitItems = {
    fields: [
        {
            name: 'id',
            label: 'id',
            validators: {}
        },
    ],
    customFields: [
    ]
};

const paCriminalComplaintSubpoenaItems = {
    fields: [
        {
            name: 'id',
            label: 'id',
            validators: {}
        },
        {
            name: 'subpoenaRemarks',
            label: 'Remarks',
            validators: {}
        },
        {
            name: 'subpoenaAdaRequiredPreliminaryHearing',
            label: 'ADA Required at Preliminary Hearing',
            validators: {}
        },
        {
            name: 'subpoenaPhotographedAndFingerprinted',
            label: 'Photographed and Fingerprinted',
            validators: {}
        },
        {
            name: 'subpoenaIssueFingerprintOrder',
            label: 'NOT Photographed and Fingerprinted - Issue Fingerprint Order',
            validators: {}
        },
        {
            name: 'subpoenaMakeConditionOfBail',
            label: 'NOT Photographed - Make Condition of Bail',
            validators: {}
        },
        {
            name: 'subpoenaArraignedByDutyMagisterialJudge',
            label: 'Arraigned by Duty Magisterial Judge',
            validators: {}
        },
        {
            name: 'subpoenaVideoArraignment',
            label: 'Video Arraignment',
            validators: {}
        },
        {
            name: 'subpoenaChargesProvidedToCentralBooking',
            label: 'Charges Provided to Central Booking',
            validators: {}
        },
        {
            name: 'subpoenaRequestFingerprintOrderBeIssued',
            label: 'Request Fingerprint Order be Issued',
            validators: {}
        },
    ],
    customFields: [
    ]
};

const chargingDocumentSubpoenaRemark = {
    fields: [
        {
            name: 'subpoenaRemarks',
            label: 'Subpoena Remarks',
            validators: {}
        }
    ],
    customFields: [
    ]
};

const chargingDocumentCharging = {
    fields: [
        {
            name: 'associatedOn',
            label: 'Linked Date',
            validators: {}
        },
        {
            name: 'arrestTypeId',
            label: 'Arrest Type',
            validators: {}
        },
        {
            name: 'comment',
            label: 'Comment',
            validators: {}
        },
        {
            name: 'detentionDate',
            label: 'Detention Date',
            validators: {}
        },
        {
            name: 'detentionAddressId',
            label: 'Detention Location',
            validators: {}
        }
    ],
    customFields: [
    ]
};
export const paCriminalComplaintAttorneyForStateFields = {
    fields: [...paCriminalComplaintAttorneyForState.fields],
    customFields: [...paCriminalComplaintAttorneyForState.customFields]
}

export const paCriminalComplaintEntityTypeFields = {
    fields: [...paCriminalComplaintEntityType.fields],
    customFields: [...paCriminalComplaintEntityType.customFields]
}

export const paCriminalComplaintPrimaryInfoFields = {
    fields: [...paCriminalComplaintPrimaryInfo.fields],
    customFields: [...paCriminalComplaintPrimaryInfo.customFields]
}

export const paCriminalComplaintAffiantFields = {
    fields: [...paCriminalComplaintAffiantItems.fields],
    customFields: [...paCriminalComplaintAffiantItems.customFields]
};

export const paCriminalComplaintDefendantFields = {
    fields: [...paCriminalComplaintDefendantItems.fields],
    customFields: [...paCriminalComplaintDefendantItems.customFields]
};

export const paCriminalComplaintAccusationFields = {
    fields: [...paCriminalComplaintAccusationItems.fields],
    customFields: [...paCriminalComplaintAccusationItems.customFields]
};

export const paCriminalComplaintChargesFields = {
    fields: [...paCriminalComplaintChargesData.fields],
    customFields: [...paCriminalComplaintChargesData.customFields]
};

export const paCriminalComplaintConfidentialInformationFields = {
    fields: [...paCriminalComplaintConfidentialInformation.fields],
    customFields: [...paCriminalComplaintConfidentialInformation.customFields]
};

export const paCriminalComplaintAffidavitFields = {
    fields: [...paCriminalComplaintAffidavitItems.fields],
    customFields: [...paCriminalComplaintAffidavitItems.customFields]
};

export const paCriminalComplaintSubpoenaFields = {
    fields: [...paCriminalComplaintSubpoenaItems.fields],
    customFields: [...paCriminalComplaintSubpoenaItems.customFields]
};

export const chargingDocumentSubpoenaRemarkFields = {
    fields: [...chargingDocumentSubpoenaRemark.fields],
    customFields: [...chargingDocumentSubpoenaRemark.customFields]
};

export const chargingDocumentChargingFields = {
    fields: [...chargingDocumentCharging.fields],
    customFields: [...chargingDocumentCharging.customFields]
};